module.exports = __webpack_public_path__ + "img/4-en.9847d14c.png";